<template>
  <!-- 柳南物流 -->
  <div id="logistics-main">
    <div class="item-list" v-for="(item, index) in dataList" :key="index">
      <h4>{{ item.name }}</h4>
      <div class="item-type">{{ item.type }}</div>
      <div class="item-route">路线：{{ item.route }}</div>
      <div class="item-time">营业时间：{{ item.time }}</div>
      <div class="item-addr">
        <img src="../assets/addr-icon.png" alt="" />
        <span>{{ item.address }}</span>
      </div>
      <div class="item-tel">
        <img src="../assets//tel-icon.png" alt="" />
        <a :href="'tel:' + showTel(item.phone)">{{ item.phone }}</a>
      </div>
    </div>
  </div>
</template>
<script>
import { getLogisticsList } from "../api/api";
export default {
  data() {
    return {
      dataList: [],
    };
  },
  created() {
    if (this.$eshimin) {
      this.$eshimin.setTitle({
        title: "柳南物流",
        onResponse: function (res) {
          console.log("setTitle res:" + res);
        },
      });
    }
    getLogisticsList().then((res) => {
      console.log(res);
      if (res.code == 200) {
        this.dataList = res.data;
      }
    });
  },
  methods: {
    showTel(val) {
      if (val.indexOf(" ") != -1) {
        return val.split(" ")[1];
      } else {
        return val;
      }
    },
  },
};
</script>
<style lang="less" scoped>
#logistics-main {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  font-size: 0;
  box-sizing: border-box;
  background: #f4f6f8;
  padding-top: 10px;
  padding-bottom: 10px;
}

.item-list {
  margin: 10px 15px;
  background: #ffffff;
  border-radius: 8px;
  padding: 15px;
  h4 {
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 24px;
  }
  .item-type {
    display: inline-block;
    background: rgba(205, 161, 105, 0.15);

    border-radius: 2px;

    font-size: 13px;
    font-family: SFCompactDisplay-Regular, SFCompactDisplay;
    font-weight: 400;
    color: #cda169;
    padding: 2px 4px 3px 4px;
    margin-top: 5px;
  }
  .item-route {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 17px;
    margin-top: 5px;
  }
  .item-time {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 17px;
    margin-top: 5px;
  }
  .item-addr {
    display: flex;
    align-items: center;
    margin-top: 21px;
    img {
      width: 16px;
      height: 16px;
    }
    span {
      margin-left: 5px;

      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 16px;
    }
  }
  .item-tel {
    display: flex;
    align-items: center;
    margin-top: 8px;
    img {
      width: 16px;
      height: 16px;
    }
    a {
      margin-left: 5px;

      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #0882f3;
      line-height: 16px;
    }
  }
}
</style>
